/* istanbul ignore file */

import { Pipe, PipeTransform } from '@angular/core';
import { FormControl } from '@angular/forms';

/**
 * Utilitary pipe to typecast an AbstractControl as FormControl.
 * This allows binding a form group control to a FormControl input.
 */
@Pipe({ name: 'valueAsFormControl', standalone: true })
export class ValueAsFormControlPipe implements PipeTransform {
  transform(value: unknown | null): FormControl {
    return new FormControl(value);
  }
}
